import React, { useContext, useState } from "react";
import { sleep } from "simple-utils";
import { Alert } from "../components/Alert";
import { useCopy } from "../components/copy-hook";
import { Loading } from "../components/Loading";
import { Modal } from "../components/Modal";
import { load } from "../loaders/basic-loader";
import { useIsAwr, useIsGuest } from "../login/AuthContext";
import { Account, getAccountLink, getAdsLink, getBillingLink } from "../models/Account";
import { useShortcut } from "../utils/utils";
import { AccountContext } from "./AccountContext";

export function NotifyBadStatusUI({cancel}:{cancel:()=>void}){
    const [state, setState] = useState<"initial" | "sending" | "sent">();
    const [error, setError] = useState<string>();

    async function notify(){
        setState("sending")
        await sleep(3000);
        try{
            const a = await load('notify-bad-status')
            setState("sent")
        }catch(e){
            setError(e.message || e.toString());
        }
    }

    if(error){
        return <Alert className="alert-danger" content={error} />
    }

    if(state == 'sending')
        return <>
            <p><b>Atenção:</b> Leva 5 segundos para cada mensagens</p>
            <Loading text="Enviando notificações..." />
        </>
    
    if(state == 'sent')
        return <p>Notificações Enviadas!</p>

    return <>
        <p>Ao clicar em notificar, você irá enviar uma mensagem para todas as contas cartão com status diferente de ativo.</p>
        <div className="text-end">
            <button className="btn btn-outline-primary mb-2 me-2" onClick={cancel}>Cancelar</button>
            <button className="btn btn-danger mb-2" onClick={notify}>Notificar</button>
        </div>
    </>
}

export function BatchModal(){
    const {filtered} = useContext(AccountContext);
    const copy = useCopy("Ids da Meta copiados!");
    const guest = useIsGuest();
    const awr =  useIsAwr();
    const [notifyBadStatusMode, setNotifyBadStatusMode] = useState(false)

    if(!filtered || !filtered.length) return <p>A lista de contas deve conter ao menos uma conta</p>
    //if(filtered.length > 30) return <p>A lista de contas deve conter 30 ou menos contas</p>



    function openLinks(fn:(a:Account)=>string, type = "billing"){
        return () => {
            filtered.slice(0, 30).forEach(a => {
                var link = fn(a);
                open(link, type + '-' + a.metaId)
            })
        }
    }

    function copyMetaIds(){
        copy(filtered.map(a => a.metaId).join('\n'));
    }

    if(notifyBadStatusMode)
        return <NotifyBadStatusUI cancel={()=>setNotifyBadStatusMode(false)} />

    return <>
        <p>Ações abaixo serão executadas para o total de {filtered.length} contas</p>

        <div className="mt-4 d-flex flex-column" style={{width: "fit-content"}}>
            <button className="btn btn-primary mb-2" onClick={openLinks(getAccountLink)}><i className="fas fa-external-link me-1"></i> Abrir Business Manager</button>
            <button className="btn btn-danger mb-2" onClick={openLinks(getBillingLink)}><i className="fas fa-dollar me-1"></i> Gerenciar Pagementos</button>
            <button className="btn btn-secondary mb-2" onClick={openLinks(getAdsLink)}><i className="fas fa-bullhorn me-1"></i> Biblioteca de anúncios</button>
            <button className="btn btn-info mb-2" onClick={copyMetaIds}><i className="fab fa-meta me-1"></i> IDs da Meta</button>
            {!guest && awr && <button className="btn btn-danger mb-2" onClick={() => setNotifyBadStatusMode(true)}><i className="fa fa-triangle-exclamation me-1"></i> Notificar Pagamentos</button>}
        </div>
    </>
}

export function BatchActions(){
    const [show, setShow] = useState(false);

    useShortcut("KeyB", () => {if(!show) setShow(true)});
    
    return <>
        {show && <Modal className="modal-primary" onHide={() => setShow(false)} title="Ações em lote"><BatchModal /></Modal>}
    </>
}